export type Config = {
    TRACK_ACTION_URL: string;
    CXF_TRACK_MSG: string;
};

export const createConfig = (config: Partial<Config>): Config => ({
    TRACK_ACTION_URL: process.env.TRACK_ACTION_URL as string,
    CXF_TRACK_MSG: 'cxf.tracking.message',
    ...config,
});
